import PropTypes from "prop-types";
import * as React from "react";
import { TextInput, Typography } from "../../themeV2";
import styles from "./AddShopDialog.module.css";
import { ACTION, ROUTE_REGEX } from "./addShopReducer";

const isValidRoute = (route) => ROUTE_REGEX.test(route);

const getRouteError = (route, serverError) => {
  if (serverError) return serverError;
  if (!route) return undefined;
  if (route.length < 4) return "Route must be at least 4 characters";
  if (route.length > 50) return "Route must be 50 characters or fewer";
  if (!ROUTE_REGEX.test(route)) return "Route must contain only letters";
  return undefined;
};

function ShopDetailsSection({ shopName, shopRoute, routeError, dispatch }) {
  const clientRouteError = shopRoute.length > 0 && !isValidRoute(shopRoute);
  const hasRouteError = clientRouteError || Boolean(routeError);
  const routeErrorMessage = getRouteError(shopRoute, routeError);
  const routeDescription =
    shopRoute && !hasRouteError ? `streamily.com/${shopRoute}` : undefined;

  return (
    <section className={styles.section}>
      <Typography variant="title-md" as="h3">
        Shop details
      </Typography>

      <TextInput
        autoFocus
        label="Shop Name"
        required
        value={shopName}
        maxLength={100}
        onChange={(e) =>
          dispatch({
            type: ACTION.SET_FIELD,
            field: "shopName",
            value: e.target.value,
          })
        }
      />

      <TextInput
        label="Shop Route"
        required
        value={shopRoute}
        error={routeErrorMessage}
        description={routeDescription}
        maxLength={50}
        pattern="[a-zA-Z]{4,50}"
        title="4–50 letters only"
        onChange={(e) =>
          dispatch({
            type: ACTION.SET_FIELD,
            field: "shopRoute",
            value: e.target.value.replace(/[^a-zA-Z]/g, ""),
          })
        }
      />
    </section>
  );
}

ShopDetailsSection.propTypes = {
  shopName: PropTypes.string.isRequired,
  shopRoute: PropTypes.string.isRequired,
  routeError: PropTypes.string,
  dispatch: PropTypes.func.isRequired,
};

export default React.memo(ShopDetailsSection);
